import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const AttachmentDeliveryMode = union([
    literal("link"),
    literal("file"),
]);
export type TAttachmentDeliveryModeCodec = typeof AttachmentDeliveryMode;
export type TAttachmentDeliveryMode = TTypeOfCodec<TAttachmentDeliveryModeCodec>;
